import { Images } from 'assets/images';

export const BackButton = ({ handleClick }) => (
  <button type="button" className="back-action" onClick={handleClick}>
    <img src={Images.backVectorIcon} />
  </button>
);
